"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.46 4.898a.7.7 0 0 1 .7-.7h3.14a.7.7 0 0 1 .7.7v10.204a.7.7 0 0 1-.7.7h-3.14a.7.7 0 0 1-.7-.7zm1.4.7v8.804h1.74V5.598z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.399 10.675a.7.7 0 0 1-.037.989l-.346.321h4.144a.7.7 0 1 1 0 1.4h-4.144l.346.322a.7.7 0 1 1-.952 1.026l-1.653-1.535a.7.7 0 0 1 0-1.026l1.653-1.534a.7.7 0 0 1 .989.037m-.667-5.389a.7.7 0 0 1 .99-.001l1.538 1.534a.7.7 0 0 1 0 .991l-1.538 1.535a.7.7 0 0 1-.988-.991l.34-.34H6.127a.7.7 0 1 1 0-1.4h3.945l-.34-.338a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 5.013a.7.7 0 0 1 .7-.7h3.069a.7.7 0 0 1 .7.7v9.974a.7.7 0 0 1-.7.7h-3.07a.7.7 0 0 1-.7-.7zm1.4.7v8.574h1.669V5.713z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ConnectorsIcon20.js.map